/* eslint-disable eslint-comments/no-restricted-disable */
/* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from '@atlassian/jira-relay/src/__generated__/PlanViewNotFoundQuery$parameters';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { plansHorizontalNavigationEntryPoint } from '@atlassian/jira-horizontal-nav-plans/entrypoint.tsx';

const main = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(
				/* webpackChunkName: "async-error-pages-plan-view-not-found-entrypoint" */ './src/PlanViewNotFound.tsx'
			),
	),
	getPreloadProps: ({
		context: { match },
		tenantContext: { cloudId, activationId },
	}: EntryPointRouteParams) => {
		const planId = match.params.planId;
		if (!planId) {
			throw new Error('Plan Id is missing');
		}

		return {
			queries: {
				mainQuery: {
					options: {
						fetchPolicy: 'store-or-network' as const,
					},
					parameters,
					variables: {
						planId: `ari:cloud:jira:${cloudId}:plan/activation/${activationId}/${planId}`,
					},
				},
			},
		};
	},
});

export const planViewNotFoundPageEntrypoint = createPageEntryPoint({
	main,
	horizontalNavigation: plansHorizontalNavigationEntryPoint,
	topNavigationMenuId: MENU_ID.PLANS,
});
